import React from 'react';
import { motion } from 'framer-motion';
import { Activity, ArrowRight, LogIn, FilePlus2, FilePenLine, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

const actionStyles = {
  create: { icon: FilePlus2, color: 'border-emerald-400/25 bg-emerald-400/10 text-emerald-300' },
  update: { icon: FilePenLine, color: 'border-sky-400/25 bg-sky-400/10 text-sky-300' },
  delete: { icon: Trash2, color: 'border-red-400/25 bg-red-400/10 text-red-300' },
  login: { icon: LogIn, color: 'border-amber-400/25 bg-amber-400/10 text-amber-300' },
  default: { icon: Activity, color: 'border-slate-400/25 bg-slate-400/10 text-slate-300' },
};

const RecentActivities = ({ activities, isAdmin, navigate }) => {
  if (!activities?.length) return null;
  return (
    <motion.section className="dashboard-glass mt-6 rounded-xl p-5 sm:p-6" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45, delay: 0.72 }} data-testid="recent-activities-panel">
      <div className="mb-5 flex items-center justify-between gap-3">
        <div><p className="dashboard-eyebrow">Audit trail</p><h2 className="mt-2 font-heading text-xl font-medium text-white">Recent activities</h2></div>
        {isAdmin && <Button variant="ghost" size="sm" onClick={() => navigate('/audit-logs')} className="text-slate-400 hover:bg-white/5 hover:text-white" data-testid="view-all-activities-button">View all <ArrowRight className="ml-2 h-4 w-4" /></Button>}
      </div>
      <div className="relative space-y-0 before:absolute before:bottom-5 before:left-5 before:top-5 before:w-px before:bg-white/10" data-testid="recent-activities-list">
        {activities.slice(0, 5).map((activity, index) => {
          const style = actionStyles[activity.action] || actionStyles.default;
          const Icon = style.icon;
          return (
            <div key={activity.log_id || index} className="relative flex items-start gap-4 py-3" data-testid={`activity-item-${activity.log_id || index}`}>
              <div className={`relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border ${style.color}`}><Icon className="h-4 w-4" /></div>
              <div className="min-w-0 flex-1 pt-1"><p className="truncate text-sm text-slate-200">{activity.details || `${activity.action} ${activity.resource_type}`}</p><p className="mt-1 text-xs text-slate-500">{new Date(activity.timestamp).toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</p></div>
              <span className="mt-1 hidden rounded-full border border-white/10 bg-white/5 px-2 py-1 text-[10px] uppercase text-slate-500 sm:inline-flex">{activity.action}</span>
            </div>
          );
        })}
      </div>
    </motion.section>
  );
};

export default RecentActivities;